import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    Category: {
      validations: []
    },
    LoyaltyNumber: {
      validations: []
    },
    AccountExtra1: {
      validations: []
    },
    Description: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    cellNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    Reference: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What type of Event?',
            options:[
              {label: 'Special Occasions' , value: 'Special Occasions'},
              {label: 'Wedding Ceremony' , value: 'Wedding Ceremony'},
              {label: 'Wedding Reception' , value: 'Wedding Reception'},
              {label: 'Wedding Ceremony & Reception' , value: 'Wedding Ceremony & Reception'},
              {label: 'Corporate' , value: 'Corporate'},
              {label: 'School Formal' , value: 'School Formal'},
              {label: 'Venue Hire' , value: 'Venue Hire'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Approximate Guest Number?',
            mapping: 'LoyaltyNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Preferred date or month?',
            mapping: 'AccountExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Comments/Additional Info. Please provide details regarding your enquiry, including best method and time to contact you.',
            mapping: 'Description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Mobile Number *',
            mapping: 'cellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?',
            options:[
              {label: 'Online' , value: 'Online'}, 
              {label: 'Previous Experience' , value: 'Previous Experience'},
              {label: 'Social Media' , value: 'Social Media'},
              {label: 'Radio, Advertisement' , value: 'Radio, Advertisement'},
              {label: 'Word of Mouth' , value: 'Word of Mouth'},
              {label: 'Other, Please specify in comments' , value: 'Other, Please specify in comments'},
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Glen Ewin Estate Contact Form',
    formId: '631',
    clientKey: '38AF96A9-3943-4E78-A37B-7E146909BACF',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your Enquiry with Glen Ewin Estate. Our Team will be in contact within 2-3 business days. Thank you.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/glenewinestate/form_structure.js